import { Injectable, signal } from '@angular/core';

/** Cargador de marca a pantalla completa (103) para operaciones bloqueantes. */
@Injectable({ providedIn: 'root' })
export class LoaderService {
  readonly message = signal<string | null>(null);

  // region show
  show(message: string): void { this.message.set(message); }

  // region hide
  hide(): void { this.message.set(null); }
}
